import React from 'react';
import { Navbar } from 'react-bootstrap';
import { CustomNavbarNav } from '@ui/components/molecules/CustomNavbarNav';
import NavbarCollapseStyles from './CustomNavbarCollapse.module.scss';

type Props = {
  links: { title: string; titleAr: string; link: string; linkAr: string }[];
};
export const CustomNavbarCollapse: React.FC<Props> = ({ links }) => {
  return (
    <>
      <div className={NavbarCollapseStyles.navbar_collapse__actions_container}>
        <Navbar.Toggle
          className={NavbarCollapseStyles.navbar_collapse__toggle}
          aria-controls="responsive-navbar-nav"
        />
      </div>
      <Navbar.Collapse
        className={NavbarCollapseStyles.navbar_collapse__container}
        id="responsive-navbar-nav"
      >
        <CustomNavbarNav links={links} />
      </Navbar.Collapse>
    </>
  );
};
